import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(stroke => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-7 -6 67 69"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.53,4.27,47,.66a1.31,1.31,0,0,0-1.78.5l-26,36.9c-3.28-2.27-6.62-4.49-9.86-6.82C8,30.35,7,29.31,5.69,30.64c-1.55,1.55-3,3.21-4.53,4.77a1.67,1.67,0,0,0,0,2.69L21.61,54.89,54.06,6A1.2,1.2,0,0,0,53.53,4.27Z",
  stroke: stroke,
  strokeMiterlimit: "10"
}))))), 'Checkmark');